import { render } from "./InsightsSummary.vue?vue&type=template&id=3b695671&scoped=true"
import script from "./InsightsSummary.vue?vue&type=script&lang=js"
export * from "./InsightsSummary.vue?vue&type=script&lang=js"

import "./InsightsSummary.vue?vue&type=style&index=0&id=3b695671&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b695671"]])

export default __exports__